export const getErrorMessage = function (errors: any) {
  if (!errors?.length) {
    return "";
  }
  let errMsg = "";
  errors.forEach((element: any) => {
    errMsg += (element?.description ?? "") + "\n";
  });
  return errMsg;
};

const SSH_KEY_SAVE_HINT =
  "\n\nTip: For SSH key authentication, use an unencrypted OpenSSH RSA private key (or a Secrets Manager name/ARN) and ensure the username is set before saving.";

/**
 * True when API validation text is specific enough that the SSH-key save hint helps (Story 1.3 AC2).
 * Intentionally narrow — avoid appending this hint to unrelated secret or auth errors.
 */
export function shouldAppendSshKeyWorkflowSaveHint(text: string): boolean {
  const t = text.trim();
  if (!t) {
    return false;
  }
  if (/BEGIN\s+(?:RSA|OPENSSH|EC|ENCRYPTED)\s+PRIVATE\s+KEY/i.test(t)) {
    return true;
  }
  if (/private\s*key|ssh\s*private|ssh\s*key\b|openssh\s+private|openssh\s+key/i.test(t)) {
    return true;
  }
  if (/key\s*material|invalid\s+.*\bkey\b/i.test(t) && /\b(ssh|sftp|rsa|openssh|pem)\b/i.test(t)) {
    return true;
  }
  if (/\bsftp\b/i.test(t) && /\b(key|private|ssh|pem|rsa|openssh)\b/i.test(t)) {
    return true;
  }
  if (/\bssh\b/i.test(t) && /\b(private\s*key|key\s*material|pem|rsa|openssh)\b/i.test(t)) {
    return true;
  }
  if (/auth\s*type.*ssh|ssh\s*key\s*auth|sshkey/i.test(t)) {
    return true;
  }
  return false;
}

/**
 * When Workflow Service returns validation text about keys/auth, append operator guidance (Story 1.3 AC2).
 */
export function enrichWorkflowSaveErrorMessage(raw: string): string {
  const t = raw.trim();
  if (!t) {
    return raw;
  }
  if (shouldAppendSshKeyWorkflowSaveHint(t)) {
    return `${t}${SSH_KEY_SAVE_HINT}`;
  }
  return raw;
}

/** Combined API detail → user string + SSH/SFTP save hints when relevant. */
export function getWorkflowSaveErrorMessage(details: any[] | undefined | null): string {
  if (!details?.length) {
    return "";
  }
  return enrichWorkflowSaveErrorMessage(getErrorMessage(details));
}
